module.exports = __webpack_public_path__ + "img/sidebar-4.c7736326.jpg";